import { render } from "./AddDeliveryAddressForm.vue?vue&type=template&id=3a04c54e"
import script from "./AddDeliveryAddressForm.vue?vue&type=script&lang=js"
export * from "./AddDeliveryAddressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import Button from "@/components/Button.vue";
script.components = Object.assign({}, { Button }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { Button }, script.__o.components);}